import * as z from "zod";

import { RawDateOnlySchema } from "@app/shared/schemas/date";

import { InstallmentSchema } from "./installment.schema";
import { PaymentMethodSchema } from "./payment-method.schema";

export const PaymentRuleSchema = z.object({
  Method: PaymentMethodSchema,
  Installments: z.array(InstallmentSchema),
  FirstInstallment: RawDateOnlySchema.nullable(),
  Interest: z.int().min(0).nullable(),
  LateFee: z.int().min(0).nullable(),
});
